export default __webpack_public_path__ + "static/media/Tekesh.5f7a44f4.jpg";